<template>
  <div :class="'alert alert-' + type" role="alert">
    {{ message }}

    <button type="button" class="close" @click="$emit('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Flash',

  props: ['message', 'type'],
};
</script>
